module.exports = __webpack_public_path__ + "static/media/bag.c4a99837.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/bag.svg
 ** module id = 121
 ** module chunks = 0
 **/